import { defineComponent as S, onMounted as O, onUnmounted as C, provide as I, computed as b, ref as p, watchEffect as V, inject as E, resolveComponent as h, createBlock as H, openBlock as L, withCtx as D, createVNode as _, renderSlot as P, Transition as U, withDirectives as A, createElementVNode as Q, vShow as R } from "vue";
import { A as $, N as k, s as q, o as d, i as w, u as B, a as v } from "./keyboard-D80SCZJ9.mjs";
import { l as z, i as y, t as F } from "./open-closed-BXrToqAS.mjs";
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var J = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(J || {});
let T = Symbol("DisclosureContext");
function x(t) {
  let n = E(T, null);
  if (n === null) {
    let r = new Error(`<${t} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, x), r;
  }
  return n;
}
let N = Symbol("DisclosurePanelContext");
function W() {
  return E(N, null);
}
let X = S({ name: "Disclosure", props: { as: { type: [Object, String], default: "template" }, defaultOpen: { type: [Boolean], default: !1 } }, setup(t, { slots: n, attrs: r }) {
  let a = p(t.defaultOpen ? 0 : 1), e = p(null), c = p(null), s = { buttonId: p(`headlessui-disclosure-button-${w()}`), panelId: p(`headlessui-disclosure-panel-${w()}`), disclosureState: a, panel: e, button: c, toggleDisclosure() {
    a.value = B(a.value, { 0: 1, 1: 0 });
  }, closeDisclosure() {
    a.value !== 1 && (a.value = 1);
  }, close(l) {
    s.closeDisclosure();
    let u = l ? l instanceof HTMLElement ? l : l.value instanceof HTMLElement ? d(l) : d(s.button) : d(s.button);
    u == null || u.focus();
  } };
  return I(T, s), F(b(() => B(a.value, { 0: y.Open, 1: y.Closed }))), () => {
    let { defaultOpen: l, ...u } = t, i = { open: a.value === 0, close: s.close };
    return $({ theirProps: u, ourProps: {}, slot: i, slots: n, attrs: r, name: "Disclosure" });
  };
} }), Y = S({ name: "DisclosureButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(t, { attrs: n, slots: r, expose: a }) {
  let e = x("DisclosureButton"), c = W(), s = b(() => c === null ? !1 : c.value === e.panelId.value);
  O(() => {
    s.value || t.id !== null && (e.buttonId.value = t.id);
  }), C(() => {
    s.value || (e.buttonId.value = null);
  });
  let l = p(null);
  a({ el: l, $el: l }), s.value || V(() => {
    e.button.value = l.value;
  });
  let u = q(b(() => ({ as: t.as, type: n.type })), l);
  function i() {
    var o;
    t.disabled || (s.value ? (e.toggleDisclosure(), (o = d(e.button)) == null || o.focus()) : e.toggleDisclosure());
  }
  function f(o) {
    var m;
    if (!t.disabled) if (s.value) switch (o.key) {
      case v.Space:
      case v.Enter:
        o.preventDefault(), o.stopPropagation(), e.toggleDisclosure(), (m = d(e.button)) == null || m.focus();
        break;
    }
    else switch (o.key) {
      case v.Space:
      case v.Enter:
        o.preventDefault(), o.stopPropagation(), e.toggleDisclosure();
        break;
    }
  }
  function g(o) {
    switch (o.key) {
      case v.Space:
        o.preventDefault();
        break;
    }
  }
  return () => {
    var o;
    let m = { open: e.disclosureState.value === 0 }, { id: j, ...K } = t, M = s.value ? { ref: l, type: u.value, onClick: i, onKeydown: f } : { id: (o = e.buttonId.value) != null ? o : j, ref: l, type: u.value, "aria-expanded": e.disclosureState.value === 0, "aria-controls": e.disclosureState.value === 0 || d(e.panel) ? e.panelId.value : void 0, disabled: t.disabled ? !0 : void 0, onClick: i, onKeydown: f, onKeyup: g };
    return $({ ourProps: M, theirProps: K, slot: m, attrs: n, slots: r, name: "DisclosureButton" });
  };
} }), Z = S({ name: "DisclosurePanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(t, { attrs: n, slots: r, expose: a }) {
  let e = x("DisclosurePanel");
  O(() => {
    t.id !== null && (e.panelId.value = t.id);
  }), C(() => {
    e.panelId.value = null;
  }), a({ el: e.panel, $el: e.panel }), I(N, e.panelId);
  let c = z(), s = b(() => c !== null ? (c.value & y.Open) === y.Open : e.disclosureState.value === 0);
  return () => {
    var l;
    let u = { open: e.disclosureState.value === 0, close: e.close }, { id: i, ...f } = t, g = { id: (l = e.panelId.value) != null ? l : i, ref: e.panel };
    return $({ ourProps: g, theirProps: f, slot: u, attrs: n, slots: r, features: k.RenderStrategy | k.Static, visible: s.value, name: "DisclosurePanel" });
  };
} });
const ee = S({
  name: "vs-disclosure",
  components: {
    Disclosure: X,
    DisclosureButton: Y,
    DisclosurePanel: Z
  },
  emits: ["disclosure:opened", "disclosure:closed"],
  setup(t, { emit: n }) {
    return {};
  }
});
function te(t, n, r, a, e, c) {
  const s = h("DisclosureButton"), l = h("DisclosurePanel"), u = h("Disclosure");
  return L(), H(u, null, {
    default: D(({ open: i }) => [
      _(s, { class: "w-full" }, {
        default: D(() => [
          P(t.$slots, "button", { open: i })
        ]),
        _: 2
      }, 1024),
      _(U, {
        "enter-active-class": "transition-all duration-500 ease-out",
        "enter-from-class": "-translate-x-4 opacity-0 max-h-0",
        "enter-to-class": "translate-x-0 opacity-100 max-h-64",
        "leave-active-class": "transition-all duration-500 ease-out",
        "leave-from-class": "translate-x-0 opacity-100 max-h-64",
        "leave-to-class": "-translate-x-4 opacity-0 max-h-0"
      }, {
        default: D(() => [
          A(Q("div", null, [
            _(l, { static: "" }, {
              default: D(() => [
                P(t.$slots, "content")
              ]),
              _: 3
            })
          ], 512), [
            [R, i]
          ])
        ]),
        _: 2
      }, 1024)
    ]),
    _: 3
  });
}
const ne = /* @__PURE__ */ G(ee, [["render", te]]);
export {
  ne as v
};
//# sourceMappingURL=vsDisclosure-egvl1r1U.mjs.map
